import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';


import { getCurrentTicketId } from '../selectors';
import { reviewTicketId } from '../actions';
import omitProps from '../../../utils/omitProps';
import queryMetaHandler from '../../../utils/queryMetaHandler';


import TicketApprovalPanel from '../components/TicketApprovalPanel';
import { TicketStatusQuery } from '../graphql/TicketStatusQuery';


const propTypes = exact({
  ticketId: PropTypes.number.isRequired,
  documentId: PropTypes.number.isRequired,
  reviewTicketIdAction: PropTypes.func.isRequired,
  canReviewTicket: PropTypes.bool.isRequired,
  isJobMutable: PropTypes.bool.isRequired,
  jobId: PropTypes.number.isRequired,
  hasTimeEntries: PropTypes.bool.isRequired,
});


const TicketApprovalReview = (props) => {
  const {
    canReviewTicket, ticketId, reviewTicketIdAction, documentId, isJobMutable, jobId,
    hasTimeEntries,
  } = props;

  return (
    <TicketApprovalPanel
      documentId={documentId}
      canReviewTicket={canReviewTicket}
      ticketId={ticketId}
      reviewTicketId={reviewTicketIdAction}
      isJobMutable={isJobMutable}
      jobId={jobId}
      hasTimeEntries={hasTimeEntries}
    />
  );
};


TicketApprovalReview.propTypes = propTypes;


const withData = graphql(TicketStatusQuery);


const mapDataToProps = withProps((props) => {
  const { data: { ticket } } = props;
  const canReviewTicket = ticket.state === 'unreviewed';
  const { documentId } = ticket.ticketNumber;
  const isJobMutable = ticket.job.mutable;
  const { hasTimeEntries } = ticket;

  return {
    canReviewTicket,
    documentId,
    isJobMutable,
    hasTimeEntries,
  };
});


const mapStateToProps = (state) => {
  return {
    ticketId: getCurrentTicketId(state),
  };
};


const mapDispatchToProps = {
  reviewTicketIdAction: reviewTicketId,
};


const withRedux = connect(mapStateToProps, mapDispatchToProps);


const enhance = compose(
  withRedux,
  withData,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);

export default enhance(TicketApprovalReview);
